import { render, staticRenderFns } from "./product.vue?vue&type=template&id=154b0d22&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&lang=less&"
import style1 from "./product.vue?vue&type=style&index=1&id=154b0d22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b0d22",
  null
  
)

export default component.exports